import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { OVERDUE_STATISTICS_GET } from 'api/query-keys';
import type { TGetOverdueStatisticsRes } from 'api/swagger';
import type { IOverdueFilter } from 'shared/stores/use-overdue-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: IOverdueFilter;
}

export const useGetOverdueStatistics = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<IOverdueFilter>(qs, filters);

  return useQuery({
    queryKey: [OVERDUE_STATISTICS_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetOverdueStatisticsRes>(`/v1/statistics/overdue?${qs.toString()}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !!filters.date,
  });
};
